/* eslint-disable */
export const maxLifetime = 0

export default [
[ 0, 100000 ],
[ 1, 99438 ],
[ 2, 99398 ],
[ 3, 99369 ],
[ 4, 99345 ],
[ 5, 99328 ],
[ 6, 99313 ],
[ 7, 99299 ],
[ 8, 99287 ],
[ 9, 99277 ],
[ 10, 99268 ],
[ 11, 99261 ],
[ 12, 99253 ],
[ 13, 99241 ],
[ 14, 99222 ],
[ 15, 99191 ],
[ 16, 99150 ],
[ 17, 99098 ],
[ 18, 99035 ],
[ 19, 98959 ],
[ 20, 98872 ],
[ 21, 98771 ],
[ 22, 98658 ],
[ 23, 98537 ],
[ 24, 98411 ],
[ 25, 98284 ],
[ 26, 98158 ],
[ 27, 98031 ],
[ 28, 97905 ],
[ 29, 97777 ],
[ 30, 97647 ],
[ 31, 97515 ],
[ 32, 97380 ],
[ 33, 97242 ],
[ 34, 97102 ],
[ 35, 96958 ],
[ 36, 96810 ],
[ 37, 96655 ],
[ 38, 96492 ],
[ 39, 96321 ],
[ 40, 96140 ],
[ 41, 95948 ],
[ 42, 95742 ],
[ 43, 95517 ],
[ 44, 95267 ],
[ 45, 94989 ],
[ 46, 94681 ],
[ 47, 94345 ],
[ 48, 93978 ],
[ 49, 93579 ],
[ 50, 93146 ],
[ 51, 92678 ],
[ 52, 92173 ],
[ 53, 91630 ],
[ 54, 91047 ],
[ 55, 90420 ],
[ 56, 89746 ],
[ 57, 89024 ],
[ 58, 88251 ],
[ 59, 87429 ],
[ 60, 86559 ],
[ 61, 85640 ],
[ 62, 84671 ],
[ 63, 83646 ],
[ 64, 82558 ],
[ 65, 81396 ],
[ 66, 80149 ],
[ 67, 78808 ],
[ 68, 77370 ],
[ 69, 75839 ],
[ 70, 74213 ],
[ 71, 72487 ],
[ 72, 70655 ],
[ 73, 68702 ],
[ 74, 66619 ],
[ 75, 64393 ],
[ 76, 62032 ],
[ 77, 59543 ],
[ 78, 56906 ],
[ 79, 54123 ],
[ 80, 51197 ],
[ 81, 48134 ],
[ 82, 44937 ],
[ 83, 41640 ],
[ 84, 38282 ],
[ 85, 34817 ],
[ 86, 31299 ],
[ 87, 27775 ],
[ 88, 24301 ],
[ 89, 20930 ],
[ 90, 17721 ],
[ 91, 14725 ],
[ 92, 11990 ],
[ 93, 9550 ],
[ 94, 7429 ],
[ 95, 5635 ],
[ 96, 4161 ],
[ 97, 2986 ],
[ 98, 2080 ],
[ 99, 1405 ],
[ 100, 918 ],
[ 101, 0 ],
[ 102, 0 ],
[ 103, 0 ],
[ 104, 0 ],
[ 105, 0 ],
[ 106, 0 ],
[ 107, 0 ],
[ 108, 0 ],
[ 109, 0 ],
[ 110, 0 ]
]
